import React, { Component } from 'react'
import './evaluation-report.scss'
import { ImageConstants, Constants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import SchoolUserApi from '../../../apis/student'

class EvalutionReport extends Component {
  state = {
    noviceStudents: [],
    proficientStudents: [],
    advancedStudents: [],
    types: []
  }

  componentDidMount () {
    const { selectedClass, gmcAllowed } = this.props
    this.gmcAllowed = gmcAllowed
    const payload = {}
    if (selectedClass && selectedClass !== 'All') {
      payload.class = selectedClass
      this.setState({
        selectedClass: payload.class
      })
    }
    this.getEvaluationReport(payload)
  }

  getEvaluationReport (payload = {}) {
    this.setState({ isLoading: true })
    payload.eventId = this.gmcAllowed ? Constants.GMC_EVENT_ID: Constants.IMD_EVENT_ID
    SchoolUserApi.getIMDEvaluationReport(payload)
      .then(response => {
        console.log(response)
        this.setState({
          noviceStudents: response.noviceStudents,
          proficientStudents: response.proficientStudents,
          advancedStudents: response.advancedStudents,
          isLoading: false
        })
      })
      .catch(err => {})
  }

  render () {
    return (
      <>
        <div className='evaluation-report'>
          <div className='report-card-wrapper'>
            {/* {this.state.types.map((type, index) => ( */}
            <div className='report-card col-4'>
              <div
                className='report-card-header'
                style={{ backgroundColor: '#8B8BF6' }}
              >
                <div className='row header-items'>
                  <div className='col-7 text-center'>
                    <span>
                      <span className='header-title'>Novice</span> |{' '}
                      <strong>{'< 50 %'}</strong>
                    </span>
                  </div>
                </div>
              </div>

              <div className='report-card-body'>
                {this.state?.noviceStudents.length ? (
                  this.state.noviceStudents.map((user, index) => (
                    <div className='row mt-4'>
                      <div className='col-2 pr-0 my-auto'>
                        <div className='user-image'>
                          {user.image ? (
                            <img
                              className='user-image'
                              alt='img'
                              src={`${user.basePath}${user.image}`}
                            />
                          ) : (
                            <img
                              className='user-image'
                              alt='img'
                              src={Constants.ALTERNATE_STUDENT_IMAGE}
                            />
                          )}
                        </div>
                      </div>
                      <div className={`col my-auto cursor-pointer `}>
                        <span className='user-name'>{user.name}</span>
                        <span className=' marks pl-2'>
                          ( Marks: {Math.round(user.mark|| 0)}%)
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='no-data text-center'>
                    <img
                      className=''
                      src={getImageSource(ImageConstants.NO_DATA)}
                    />
                    <div className='empty'>This is Empty</div>
                    <div className='no-student'>No Student in this bucket</div>
                  </div>
                )}
              </div>
            </div>
            <div className='report-card col-4'>
              <div
                className='report-card-header'
                style={{ backgroundColor: '#FFBB7C' }}
              >
                <div className='row header-items'>
                  <div className='col-7 text-center'>
                    <span>
                      <span className='header-title pl-4'>Proficient</span> |{' '}
                      <strong>{'50%-80%'}</strong>
                    </span>
                  </div>
                </div>
              </div>

              <div className='report-card-body'>
                {this.state?.proficientStudents.length ? (
                  this.state.proficientStudents.map((user, index) => (
                    <div className='row mt-4'>
                      <div className='col-2 pr-0 my-auto'>
                        <div className='user-image'>
                          {user.image ? (
                            <img
                              className='user-image'
                              alt='img'
                              src={`${user.basePath}${user.image}`}
                            />
                          ) : (
                            <img
                              className='user-image'
                              alt='img'
                              src={Constants.ALTERNATE_STUDENT_IMAGE}
                            />
                          )}
                        </div>
                      </div>
                      <div className={`col my-auto cursor-pointer `}>
                        <span className='user-name'>{user.name}</span>
                        <span className=' marks pl-2'>
                          ( Marks: {Math.round(user.mark|| 0)}%)
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='no-data text-center'>
                    <img
                      className=''
                      src={getImageSource(ImageConstants.NO_DATA)}
                    />
                    <div className='empty'>This is Empty</div>
                    <div className='no-student'>No Student in this bucket</div>
                  </div>
                )}
              </div>
            </div>
            <div className='report-card col-4'>
              <div
                className='report-card-header'
                style={{ backgroundColor: '#80D2F4' }}
              >
                <div className='row header-items'>
                  <div className='col-7 text-center'>
                    <span>
                      <span className='header-title'>Advance</span> |{' '}
                      <strong>{'> 80 %'}</strong>
                    </span>
                  </div>
                </div>
              </div>

              <div className='report-card-body'>
                {this.state?.advancedStudents.length ? (
                  this.state.advancedStudents.map((user, index) => (
                    <div className='row mt-4'>
                      <div className='col-2 pr-0 my-auto'>
                        <div className='user-image'>
                          {user.image ? (
                            <img
                              className='user-image'
                              alt='img'
                              src={`${user.basePath}${user.image}`}
                            />
                          ) : (
                            <img
                              className='user-image'
                              alt='img'
                              src={Constants.ALTERNATE_STUDENT_IMAGE}
                            />
                          )}
                        </div>
                      </div>
                      <div className={`col my-auto cursor-pointer `}>
                        <span className='user-name'>{user.name}</span>
                        <span className=' marks pl-2'>
                          ( Marks: {Math.round(user.mark|| 0)}%)
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='no-data text-center'>
                    <img
                      className=''
                      src={getImageSource(ImageConstants.NO_DATA)}
                    />
                    <div className='empty'>This is Empty</div>
                    <div className='no-student'>No Student in this bucket</div>
                  </div>
                )}
              </div>
            </div>
            {/* ))} */}
          </div>
        </div>
      </>
    )
  }
}

export default EvalutionReport
